const CreditNoteData = [
  {
    "orderData": {
      "sct_id": "credit note id",
      "store_id": "store id",
      "cmr_phone_number": "customer phone number",
      "sct_total_gst": "0.00",
      "sct_total_discount": "0.00",
      "sct_payment_status": "payment status",
      "sct_transaction_id": "transaction id",
      "sct_order_status": "order status",
      "sct_payment_method": "payment method",
      "sct_billing_address": "billing address",
      "sct_total_amount": "0.00",
      "sct_sub_total": "0.00",
      "sct_round_off_value": "0.00",
      "sct_delivery_date": "2025-12-31",
      "sct_document_date": "2025-12-31",
      "cmr_code": "customer code",
      "cmr_name": "customer name",
      "cmr_id": "customer id",
      "remarks": "remarks",
      "created_date": "2025-12-31",
      "update_date": "2025-12-31",
      "tds_tcs_type": "tds or tcs type",
      "tcs_or_tds_percentage": "0.00",
      "tcs_or_tds_amount": "0.00",
      "tcs_or_tds_percentage_id": "tds/tcs percentage id"
    },
    "itemData": [
      {
        "item_id": "item id",
        "item_code": "item code",
        "item_generic_name": "generic name",
        "item_name": "product name",
        "item_pack_size": "pack size",
        "item_rack_location": "rack location",
        "item_unit_price": "0.00",
        "item_quantity": "0.00",
        "item_schedule": "schedule",
        "item_discount_amount": "0.00",
        "item_discount_percentage": "0.00",
        "item_tax_amount": "0.00",
        "item_batch_number": "batch number",
        "item_total_tax_percentage": "0.00",
        "item_total_amount": "0.00",
        "item_batch_quantity": "0.00",
        "srt_id": "return transaction id",
        "soit_id": "sales order item transaction id",
        "item_exp_date": "2025-12-31",
        "item_gst": "0.00",
        "item_sgst": "0.00",
        "item_cgst": "0.00",
        "item_igst": "0.00",
        "item_uom": "unit of measure",
        "item_hsn": "HSN code",
        "item_manufacturer_id": "manufacturer id",
        "item_manufacturer_name": "manufacturer name",
        "item_free_quantity": "0.00",
        "item_to_be_delivered": "0.00",
        "itemBatchData": [
          {
            "item_batch_number": "batch number",
            "item_id": "item id",
            "item_batch_quantity": "0.00",
            "item_exp_date": "2025-12-31",
            "item_batch_purchase_rate": "0.00",
            "item_batch_unit_price": "0.00",
            "from_bin_location": "bin location",
            "from_bin_id": "bin id",
            "item_batch_free_quantity": "0.00",
            "item_batch_discount_amount": "0.00",
            "item_batch_discount_percentage": "0.00",
            "item_batch_tax_percentage": "0.00",
            "item_batch_tax_amount": "0.00",
            "item_batch_total_sales_rate": "0.00",
            "item_batch_final_sales_rate": "0.00",
            "item_batch_sales_rate": "0.00"
          }
        ]
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default { CreditNoteData,storeDetailsResult_sample };
